import { cls, marketUrl } from "@/utils/util";
import { NavLink } from "react-router-dom";
import FooterFlag from "@/component/FooterFlag";

const AiBadge = () => {
  return (
    <div className="absolute right-[12%] -top-[7px] w-[28px] h-4 mr-1 bg-gradient-to-r from-[#6533E8] to-[#607EE1] px-[3px] text-white rounded-sm flex items-center">
      <span className="w-[10px] h-[10px] bg-[url('/img/ai/icon-badge.svg')] bg-no-repeat bg-center bg-cover"></span>
      <span className="!text-[#fff] text-[11px] font-bold !bg-transparent">AI</span>
    </div>
  );
};

const menuItems = [
  {
    title: "홈",
    icon: "ii ii-home-outline",
    path: "/",
  },
  {
    title: "클래스",
    icon: "ii ii-user-screen-outline",
    path: "/class",
  },
  {
    title: "마켓",
    icon: "ii ii-cart-outline",
    path: marketUrl("/market"),
    badge: <FooterFlag value="market" />,
  },
  {
    title: "게시판",
    icon: "ii ii-document-with-lines-outline",
    path: "/post",
  },
  {
    title: "Q&A/임상",
    icon: "ii ii-message-outline",
    path: "/qna",
    badge: <AiBadge />,
  },
];

const BottomNavigation = () => {
  return (
    <div className="block lg:hidden">
      <menu className="fixed bottom-0 left-0 right-0 z-20 border-t bg-base border-base">
        <ul className="flex justify-evenly w-full">
          {menuItems.map((menuItem) => (
            <li className="relative flex-1 flex flex-col items-center py-2.5" key={menuItem.title}>
              {menuItem.badge}
              <NavLink
                to={menuItem.path}
                className={({ isActive }) => {
                  return cls(
                    isActive ? "!text-primary" : "text-secondary",
                    "text-[10px] text-center",
                  );
                }}
              >
                <i className={cls(menuItem.icon, "block text-2xl text-inherit")}></i>
                {menuItem.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </menu>
    </div>
  );
};

export default BottomNavigation;
